/**
 * Created by jonas on 2022-06-15.
 */
import {SimplePresentation, SimplePresentationRunnerController} from "../winpresentation/SimplePresentationRunner";
import {KitchenDramaSushiMania} from "../KitchenDramaSushiMania";
import {AvalancheWinInfo} from "../server/KitchenDramaSushiManiaData";
import {KitchenDramaSushiManiaSymbol, KitchenDramaSushiManiaSymbolStates} from "../reels/KitchenDramaSushiManiaSymbol";
import {GSAPUtils} from "../utils/GSAPUtils";
import {gsap} from "gsap";
import {StateMatrix} from "../utils/StateMatrix";
import {KitchenDramaSushiManiaReelsView} from "../reels/KitchenDramaSushiManiaReelsView";
import {KitchenDramaSushiManiaSound} from "../sound/KitchenDramaSushiManiaSound";
import {KitchenDramaSushiManiaStatics} from "../utils/KitchenDramaSushiManiaStatics";

export class KamisabiRemovePresentation implements SimplePresentation {
    name:string = "KamisabiRemovePresentation";
    private roundIndex:number;
    private winInfo:AvalancheWinInfo;

    constructor(index:number) {
        this.roundIndex = index;
    }

    shouldRun():boolean {
        return KitchenDramaSushiMania.model.gameData.kamisabiRemove[this.roundIndex] != null;
    }

    start(controller:SimplePresentationRunnerController):void {
        const kamisabiPositions = StateMatrix.tuples2Coords(KitchenDramaSushiMania.model.gameData.kamisabiRemove[this.roundIndex]);

        let hasMidWin = false;
        const winAnimations = []
        for (let winPos of kamisabiPositions){
            const symbolData = KitchenDramaSushiMania.reelView.getVisibleSymbolDataAt(winPos.column,winPos.row);
            symbolData.removed = true;
            if (KitchenDramaSushiManiaStatics.MID_SYMBOLS.indexOf(symbolData.name) >= 0){
                hasMidWin = true;
            }
            winAnimations.push((<KitchenDramaSushiManiaSymbol>symbolData.positionable).playKamisabiRemove());
        }


        const tl:gsap.core.Timeline = gsap.timeline({onComplete:() => controller.finish()});
        tl.add(KitchenDramaSushiMania.kamisabiCollectView.playWinAnimation());
        tl.add(()=>{
            KitchenDramaSushiMania.kamisabiCollectView.stopKamisabiLogoAnim();
        });
        tl.add(KitchenDramaSushiMania.kamisabiSplashView.show());
        tl.add(KitchenDramaSushiMania.kamisabiCollectView.playWinReset());
        const startFall = tl.totalDuration() + 0.2;
        tl.add(GSAPUtils.createTimelineFromArray(winAnimations, "<0.05"));
        tl.add(()=>{KitchenDramaSushiMania.soundPlayer.playSound(KitchenDramaSushiManiaSound.KAMISABI_FALLING)}, startFall);
        tl.add(()=>{KitchenDramaSushiMania.soundPlayer.playSound(KitchenDramaSushiManiaSound.KAMISABI_SPLAT)}, startFall + 1);

        if (hasMidWin){
            tl.add(()=>{KitchenDramaSushiMania.soundPlayer.playSound(KitchenDramaSushiManiaSound.KAMISABI_MELT_MID_WINS)}, "-=2.16");
        } else {
            tl.add(()=>{KitchenDramaSushiMania.soundPlayer.playSound(KitchenDramaSushiManiaSound.KAMISABI_MELT_LOW_SYMS)}, "-=2.16");
        }

    }
}